// extracted by mini-css-extract-plugin
export default {"imageContainer":"t1-z","summaryPar":"u1-z","ratingCategories":"v1-z","reviewerInfo":"w1-z","reviewTypes":"x1-z","expanded":"y1-z"};